<template>
  <div v-if="value" class="sticky-menu">
    <div class="sticky-menu__logo">LG MAGNIT</div>
    <ul class="sticky-menu__items">
      <li
        v-for="(item, index) in items"
        :key="`sticky-menu-item-${index + 1}`"
        class="sticky-menu__item"
        :class="{ 'sticky-menu__item--active': index === currentMenu }"
      >
        <button
          type="button"
          class="sticky-menu__anchor"
          @click="$emit('click', index)"
        >
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StickyMenu',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentMenu: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      items: [
        {
          label: `3 More 3 Less`,
        },
        {
          label: `Line Up`,
        },
        {
          label: `Usage Case`,
        },
        {
          label: `FAQ`,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';

$sticky: '.sticky-menu';
#{$sticky} {
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  &__logo {
    font-size: 24px;
    font-weight: 400;
  }
  &__items {
    display: flex;
    gap: 48px;
    height: 100%;
    margin-right: 50px;
  }
  &__item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    &--active {
      border-bottom: solid 2px #000;
    }
  }
  &__anchor {
    font-size: 24px;
    font-weight: 400;
    color: #000;
  }
  @media screen and (max-width: 1080px) {
    height: calcQuarter(200);
    justify-content: center;
    border-bottom: 1px solid #c9caca;
    &__logo {
      display: none;
    }
    &__items {
      margin-right: 0;
      gap: calcQuarter(118);
    }
    &__anchor {
      font-size: calcQuarter(48);
      color: #000;
    }
  }
}
</style>
